import { createSelector } from 'reselect';
import RfidMovementCountReportColumns from '../../containers/RfidMovementCountReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_RFID_MOVEMENT_COUNT.isLoading;
export const getData = TableDefinitions.REPORTING_RFID_MOVEMENT_COUNT.getDataFunction();
export const getColumns = createSelector(getData, RfidMovementCountReportColumns);
